import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { FormEvent } from 'react'
import * as moment from 'moment'

import ContactsComponent from '../../components/contacts'
import { AppState } from '../../store'
import { CreateContactParams, createContactWorker } from '../../actions/contacts'

interface OwnProps {
}

interface Props {
	isCreating: boolean
	createSuccess: boolean
}

interface DispatchProps {
	handlers: {
		onSubmit: (e: FormEvent<HTMLFormElement>) => void
	}
}

export type MergedProps = OwnProps & Props & DispatchProps

interface ContactsCreateFormEventTarget extends EventTarget {
	questionType: HTMLInputElement
	companyName: HTMLInputElement
	staffName: HTMLInputElement
	email: HTMLInputElement
	telephone: HTMLInputElement
}

const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
	return Object.assign(
		{
			isCreating: state.contactsState.isCreating,
			createSuccess: state.contactsState.createSuccess
		},
		ownProps
	)
}

const mapDispatchToProps = (dispatch: Dispatch<void>): DispatchProps => {
	return {
		handlers: {
			onSubmit: (e) => {
				const target = e.target as ContactsCreateFormEventTarget
				if (
					target.companyName.value === '' ||
					target.staffName.value === '' ||
					target.email.value === '' ||
					target.telephone.value === ''
				) {
					return
				}

				const params = {
					questionType: target.questionType.value,
					companyName: target.companyName.value,
					staffName: target.staffName.value,
					email: target.email.value,
					telephone: target.telephone.value,
					createdAt: moment().unix()
				} as CreateContactParams
				createContactWorker(dispatch, params).then()
			}
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactsComponent)



// WEBPACK FOOTER //
// ./src/containers/contacts/index.ts